import { render, staticRenderFns } from "./SpecialTopicPage.vue?vue&type=template&id=19303850&scoped=true&"
import script from "./SpecialTopicPage.vue?vue&type=script&lang=ts&"
export * from "./SpecialTopicPage.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialTopicPage.vue?vue&type=style&index=0&id=19303850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19303850",
  null
  
)

export default component.exports